import { render, staticRenderFns } from "./ModalResetPassword.vue?vue&type=template&id=7f27e698&"
import script from "./ModalResetPassword.vue?vue&type=script&lang=js&"
export * from "./ModalResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalResetPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports